import { render, staticRenderFns } from "./SettingsAccount.vue?vue&type=template&id=033e9dc2"
import script from "./SettingsAccount.vue?vue&type=script&lang=js"
export * from "./SettingsAccount.vue?vue&type=script&lang=js"
import style0 from "./SettingsAccount.vue?vue&type=style&index=0&id=033e9dc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports